import { render, staticRenderFns } from "./TextSkeleton.vue?vue&type=template&id=2e595fa8&scoped=true"
import script from "./TextSkeleton.vue?vue&type=script&lang=js"
export * from "./TextSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TextSkeleton.vue?vue&type=style&index=0&id=2e595fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e595fa8",
  null
  
)

export default component.exports